<template>
    <FormInput :context="context">
        <PrimeVueInputText
            v-model="value"
            v-bind="attributes"
            v-on="$listeners"
            v-if="!isDisabled"
        />
        <div v-if="isDisabled" class="supplios-form-field-preview">
            <div class="p-inputtext p-component p-filled" disabled="true">
                <a :href="value" target="_blank">
                    {{ value }}
                </a>
                &nbsp;
            </div>
        </div>
    </FormInput>
</template>

<script>
import FormInputMixin from "@/components/forms/inputs/mixins/FormInputMixin";
import PrimeVueInputText from "primevue/inputtext";

export default {
    components: { PrimeVueInputText },
    mixins: [FormInputMixin],
    data() {
        return {
            emptyValue: "",  // overriding the default from mixin of null
            // this is a CharField in backend, and value should either be omittied, or "", but null is not allowed by default
        }
    },
    computed: {
        isDisabled() {
            return this.attributes.disabled;
        },
    },
};
</script>

<style scoped lang="sass">
    .p-inputtext
        padding: 0.75em
        line-height: 1.2em
        font-size: 1em
</style>